
// Extensive Emoji Map
// Categories: Core, Business, Tech, Finance, People, Nature, Food, Objects, Activities, Symbols

const emojiMap: { [key: string]: string } = {
  // --- CORE / STRUCTURE ---
  "root": "🌳", "core": "⚛️", "main": "📌", "start": "🏁", "end": "🛑",
  "goal": "🎯", "target": "🎯", "scope": "🔭", "vision": "👁️", "mission": "🚀",
  "pro": "✅", "con": "❌", "plus": "➕", "minus": "➖", "question": "❓",
  "answer": "❗️", "idea": "💡", "tip": "💡", "hint": "🔑", "key": "🔑",
  "important": "⭐", "star": "⭐", "warning": "⚠️", "alert": "🚨", "stop": "🛑",
  "done": "✅", "todo": "☐", "list": "📝", "note": "📝", "draft": "✏️",
  "section": "§", "part": "🧩", "link": "🔗", "connect": "🔗", "web": "🌐",

  // --- JAPANESE CORE ---
  "ルート": "🌳", "コア": "⚛️", "メイン": "📌", "開始": "🏁", "終了": "🛑", "終わり": "🛑",
  "目標": "🎯", "ターゲット": "🎯", "範囲": "🔭", "ビジョン": "👁️", "ミッション": "🚀",
  "メリット": "✅", "デメリット": "❌", "プラス": "➕", "マイナス": "➖", "質問": "❓", "はてな": "❓",
  "答え": "❗️", "回答": "❗️", "アイデア": "💡", "ヒント": "🔑", "鍵": "🔑", "キー": "🔑",
  "重要": "⭐", "星": "⭐", "警告": "⚠️", "注意": "⚠️", "停止": "🛑",
  "完了": "✅", "済": "✅", "未完了": "☐", "リスト": "📝", "メモ": "📝", "下書き": "✏️",
  "リンク": "🔗", "接続": "🔗", "ウェブ": "🌐",

  // --- BUSINESS & MANAGEMENT ---
  "business": "💼", "work": "💼", "job": "👔", "office": "🏢", "company": "🏢",
  "meeting": "🤝", "meet": "🤝", "client": "🤝", "partner": "🤛", "deal": "🤝",
  "team": "👥", "group": "👥", "staff": "👥", "manager": "🤵", "boss": "🤵",
  "strategy": "♟️", "tactic": "♟️", "plan": "📅", "schedule": "📆", "calendar": "🗓️",
  "timeline": "⏳", "deadline": "⏰", "urgent": "🔥", "time": "⏰", "date": "📅",
  "project": "🚀", "launch": "🚀", "ship": "🚢", "deliver": "📦", "product": "📦",
  "service": "🛎️", "support": "🎧", "help": "🆘", "faq": "ℹ️", "info": "ℹ️",
  "report": "📄", "document": "📄", "file": "📁", "folder": "📂", "paper": "📝",
  "chart": "📊", "graph": "📈", "trend": "📈", "stats": "📉", "data": "🗃️",
  "analysis": "🔍", "research": "🔬", "presentation": "📽️", "slide": "🖼️", "demo": "🎭",
  "marketing": "📢", "ad": "📢", "promo": "🏷️", "brand": "™️", "logo": "📛",
  "market": "🌍", "global": "🌐", "local": "📍", "location": "📍",
  "success": "🏆", "win": "🥇", "winner": "🥇", "medal": "🏅", "award": "🎗️",
  "fail": "👎", "loss": "📉", "growth": "🌱", "scale": "⚖️", "profit": "💰",

  // --- JAPANESE BUSINESS ---
  "ビジネス": "💼", "仕事": "💼", "職業": "👔", "オフィス": "🏢", "会社": "🏢", "企業": "🏢",
  "会議": "🤝", "ミーティング": "🤝", "クライアント": "🤝", "顧客": "🤝", "パートナー": "🤛", "取引": "🤝",
  "チーム": "👥", "グループ": "👥", "スタッフ": "👥", "マネージャー": "🤵", "上司": "🤵", "社長": "🤵",
  "戦略": "♟️", "戦術": "♟️", "計画": "📅", "プラン": "📅", "スケジュール": "📆", "カレンダー": "🗓️", "予定": "📆",
  "タイムライン": "⏳", "締め切り": "⏰", "期限": "⏰", "緊急": "🔥", "時間": "⏰", "日付": "📅",
  "プロジェクト": "🚀", "ローンチ": "🚀", "出荷": "🚢", "納品": "📦", "製品": "📦", "プロダクト": "📦",
  "サービス": "🛎️", "サポート": "🎧", "ヘルプ": "🆘", "助けて": "🆘", "情報": "ℹ️",
  "レポート": "📄", "報告": "📄", "ドキュメント": "📄", "書類": "📄", "ファイル": "📁", "フォルダ": "📂", "紙": "📝",
  "チャート": "📊", "グラフ": "📈", "トレンド": "📈", "統計": "📉", "データ": "🗃️",
  "分析": "🔍", "研究": "🔬", "リサーチ": "🔬", "プレゼン": "📽️", "スライド": "🖼️", "デモ": "🎭",
  "マーケティング": "📢", "広告": "📢", "宣伝": "📢", "プロモーション": "🏷️", "ブランド": "™️", "ロゴ": "📛",
  "市場": "🌍", "グローバル": "🌐", "ローカル": "📍", "場所": "📍", "位置": "📍",
  "成功": "🏆", "勝利": "🥇", "優勝": "🥇", "メダル": "🏅", "賞": "🎗️",
  "失敗": "👎", "損失": "📉", "成長": "🌱", "規模": "⚖️", "利益": "💰",

  // --- FINANCE & MONEY ---
  "money": "💰", "cash": "💵", "dollar": "💵", "euro": "€", "yen": "¥",
  "pound": "£", "bank": "🏦", "credit": "💳", "card": "💳", "wallet": "👛",
  "price": "🏷️", "cost": "💸", "expense": "💸", "budget": "📉", "bill": "🧾",
  "receipt": "🧾", "tax": "🏛️", "invest": "📈", "stock": "📈", "trade": "🤝",
  "rich": "🤑", "poor": "💸", "save": "🐷", "discount": "％", "sale": "🛍️",
  "buy": "🛒", "sell": "🏷️", "pay": "💳", "refund": "↩️", "value": "💎",

  // --- JAPANESE FINANCE ---
  "金": "💰", "お金": "💰", "現金": "💵", "ドル": "💵", "円": "¥",
  "銀行": "🏦", "クレジット": "💳", "カード": "💳", "財布": "👛",
  "価格": "🏷️", "値段": "🏷️", "コスト": "💸", "費用": "💸", "経費": "💸", "予算": "📉", "請求書": "🧾",
  "レシート": "🧾", "領収書": "🧾", "税金": "🏛️", "投資": "📈", "株": "📈", "貿易": "🤝",
  "金持ち": "🤑", "貧乏": "💸", "貯金": "🐷", "割引": "％", "セール": "🛍️",
  "買う": "🛒", "購入": "🛒", "売る": "🏷️", "販売": "🏷️", "支払": "💳", "返金": "↩️", "価値": "💎",

  // --- TECH & DEVELOPMENT ---
  "tech": "💻", "computer": "💻", "pc": "🖥️", "mac": "🖥️", "laptop": "💻",
  "phone": "📱", "mobile": "📱", "app": "📱", "tablet": "📟", "watch": "⌚",
  "keyboard": "⌨️", "mouse": "🖱️", "screen": "🖥️", "monitor": "🖥️", "display": "🖥️",
  "code": "👨‍💻", "program": "💻", "software": "💾", "hardware": "🔧", "dev": "👨‍💻",
  "git": "🐙", "github": "🐙", "branch": "🌿", "commit": "✅", "merge": "🔀",
  "database": "🗄️", "db": "🗄️", "sql": "🗃️", "server": "📡", "cloud": "☁️",
  "network": "🕸️", "wifi": "📶", "internet": "🌐", "online": "🟢", "offline": "🔴",
  "security": "🛡️", "secure": "🔒", "lock": "🔒", "unlock": "🔓",
  "password": "🔑", "login": "➡️", "logout": "⬅️", "user": "👤", "admin": "👮",
  "bug": "🐛", "fix": "🩹", "issue": "⚠️", "error": "❌", "crash": "💥",
  "test": "🧪", "debug": "🐞", "api": "🔌", "plug": "🔌",
  "react": "⚛️", "vue": "🟢", "angular": "🅰️", "node": "🟩", "js": "📜",
  "ts": "📘", "python": "🐍", "java": "☕", "html": "📄", "css": "🎨",
  "linux": "🐧", "windows": "🪟", "apple": "🍎", "android": "🤖", "ios": "📱",
  "ai": "🤖", "bot": "🤖", "robot": "🤖", "ml": "🧠", "algo": "🧮",

  // --- JAPANESE TECH ---
  "技術": "💻", "テック": "💻", "コンピュータ": "💻", "パソコン": "🖥️", "ノートPC": "💻",
  "電話": "📱", "スマホ": "📱", "携帯": "📱", "アプリ": "📱", "タブレット": "📟", "時計": "⌚",
  "キーボード": "⌨️", "マウス": "🖱️", "画面": "🖥️", "モニター": "🖥️", "ディスプレイ": "🖥️",
  "コード": "👨‍💻", "プログラム": "💻", "ソフト": "💾", "ハード": "🔧", "開発": "👨‍💻",
  "ブランチ": "🌿", "コミット": "✅", "マージ": "🔀",
  "データベース": "🗄️", "サーバー": "📡", "クラウド": "☁️",
  "ネットワーク": "🕸️", "ワイファイ": "📶", "インターネット": "🌐", "オンライン": "🟢", "オフライン": "🔴",
  "セキュリティ": "🛡️", "安全": "🔒", "ロック": "🔒",
  "パスワード": "🔑", "ログイン": "➡️", "ログアウト": "⬅️", "ユーザー": "👤", "管理者": "👮",
  "バグ": "🐛", "修正": "🩹", "問題": "⚠️", "エラー": "❌", "クラッシュ": "💥",
  "テスト": "🧪", "デバッグ": "🐞",
  "人工知能": "🤖", "ロボット": "🤖", "アルゴリズム": "🧮",

  // --- COMMUNICATION ---
  "email": "📧", "mail": "✉️", "inbox": "📥", "send": "📤", "post": "📮",
  "chat": "💬", "msg": "💬", "message": "💬", "sms": "🗨️", "text": "📝",
  "call": "📞", "contact": "📒", "address": "🏠", "social": "🗣️",
  "share": "🔗", "like": "👍", "comment": "💬", "tweet": "🐦",
  "video": "📹", "zoom": "📹", "camera": "📷", "photo": "📸", "image": "🖼️",
  "audio": "🔉", "sound": "🔊", "voice": "🎤", "mic": "🎤", "speak": "🗣️",

  // --- JAPANESE COMMUNICATION ---
  "メール": "📧", "手紙": "✉️", "受信箱": "📥", "送信": "📤", "ポスト": "📮",
  "チャット": "💬", "メッセージ": "💬", "SMS": "🗨️", "テキスト": "📝",
  "通話": "📞", "連絡": "📒", "住所": "🏠", "ソーシャル": "🗣️",
  "共有": "🔗", "シェア": "🔗", "いいね": "👍", "コメント": "💬", "ツイート": "🐦", "投稿": "📝",
  "ビデオ": "📹", "動画": "📹", "カメラ": "📷", "写真": "📸", "画像": "🖼️",
  "オーディオ": "🔉", "音": "🔊", "音声": "🎤", "マイク": "🎤", "話す": "🗣️",

  // --- PEOPLE & ROLES ---
  "people": "👥", "person": "👤", "man": "👨", "woman": "👩", "child": "👶",
  "boy": "👦", "girl": "👧", "family": "👨‍👩‍👧‍👦", "parent": "👪", "friend": "👫",
  "student": "🎓", "teacher": "👩‍🏫", "doctor": "👨‍⚕️", "nurse": "👩‍⚕️", "police": "👮",
  "artist": "🎨", "musician": "🎵", "actor": "🎭", "writer": "✍️", "chef": "👨‍🍳",
  "king": "👑", "queen": "👑", "leader": "🦁", "hero": "🦸", "villain": "🦹",

  // --- JAPANESE PEOPLE ---
  "人々": "👥", "人": "👤", "男": "👨", "女": "👩", "子供": "👶",
  "男の子": "👦", "女の子": "👧", "家族": "👨‍👩‍👧‍👦", "親": "👪", "友達": "👫", "友人": "👫",
  "学生": "🎓", "生徒": "🎓", "先生": "👩‍🏫", "教師": "👩‍🏫", "医者": "👨‍⚕️", "看護師": "👩‍⚕️", "警察": "👮",
  "芸術家": "🎨", "音楽家": "🎵", "俳優": "🎭", "作家": "✍️", "シェフ": "👨‍🍳",
  "王": "👑", "女王": "👑", "リーダー": "🦁", "ヒーロー": "🦸", "悪役": "🦹",

  // --- EMOTIONS & STATUS ---
  "happy": "😊", "joy": "😂", "smile": "🙂", "love": "❤️", "heart": "❤️",
  "dislike": "👎", "hate": "💔", "sad": "😢", "cry": "😭",
  "angry": "😠", "mad": "😡", "rage": "🤬", "serious": "😐", "shy": "😳", "scared": "😱",
  "scare": "😨", "worry": "😟", "confused": "😕", "cool": "😎", "party": "🎉",
  "peace": "✌️", "ok": "👌", "thumbsup": "👍", "thumbsdown": "👎", "clap": "👏",
  "pray": "🙏", "flex": "💪", "brain": "🧠", "mind": "🧠", "think": "🤔",
  "sleep": "😴", "sick": "🤒", "dream": "💭", "health": "🏥",

  // --- JAPANESE EMOTIONS ---
  "幸せ": "😊", "喜び": "😂", "笑顔": "🙂", "愛": "❤️", "心": "❤️", "ハート": "❤️",
  "好き": "👍", "嫌い": "👎", "憎しみ": "💔", "悲しい": "😢", "泣く": "😭",
  "怒り": "😠", "激怒": "🤬", "真剣": "😐", "恥ずかしい": "😳", "怖い": "😱",
  "心配": "😟", "混乱": "😕", "クール": "😎", "パーティー": "🎉",
  "平和": "✌️", "OK": "👌", "拍手": "👏",
  "祈り": "🙏", "力": "💪", "脳": "🧠", "思考": "🤔", "考える": "🤔",
  "睡眠": "😴", "寝る": "😴", "病気": "🤒", "夢": "💭", "健康": "🏥",

  // --- NATURE & WEATHER ---
  "nature": "🌿", "tree": "🌲", "forest": "🌳", "flower": "🌸", "plant": "🌱",
  "leaf": "🍃", "fruit": "🍎", "food": "🍔", "drink": "🥤", "water": "💧",
  "fire": "🔥", "sun": "☀️", "moon": "🌙", "space": "🌌",
  "planet": "🌍", "earth": "🌍", "world": "🌍", "map": "🗺️", "mountain": "⛰️",
  "ocean": "🌊", "river": "🌊", "rain": "🌧️", "snow": "❄️", "wind": "💨",
  "animal": "🐾", "dog": "🐕", "cat": "🐈", "bird": "🐦", "fish": "🐟",
  "bee": "🐝", "rose": "🌹", "cactus": "🌵",

  // --- JAPANESE NATURE ---
  "自然": "🌿", "木": "🌲", "森": "🌳", "花": "🌸", "植物": "🌱",
  "葉": "🍃", "果物": "🍎", "食べ物": "🍔", "飲み物": "🥤", "水": "💧",
  "火": "🔥", "太陽": "☀️", "月": "🌙", "宇宙": "🌌",
  "惑星": "🌍", "地球": "🌍", "世界": "🌍", "地図": "🗺️", "山": "⛰️",
  "海": "🌊", "川": "🌊", "雨": "🌧️", "雪": "❄️", "風": "💨",
  "動物": "🐾", "犬": "🐕", "猫": "🐈", "鳥": "🐦", "魚": "🐟",
  "虫": "🐞", "蜂": "🐝", "バラ": "🌹", "サボテン": "🌵",

  // --- OBJECTS & TOOLS ---
  "tool": "🛠️", "hammer": "🔨", "build": "🏗️", "craft": "🎨", "pen": "🖊️",
  "pencil": "✏️", "book": "📖", "read": "📚", "write": "✍️", "learn": "🎓",
  "school": "🏫", "class": "🏫", "science": "🧪", "math": "🧮", "history": "📜",
  "art": "🎨", "music": "🎵", "song": "🎶", "game": "🎮", "play": "🎮",
  "sport": "⚽", "ball": "⚽", "run": "🏃", "gym": "🏋️",
  "car": "🚗", "bus": "🚌", "train": "🚆", "plane": "✈️", "travel": "🧳",
  "home": "🏠", "house": "🏡", "room": "🚪",
  "gift": "🎁", "box": "📦", "bag": "👜",

  // --- JAPANESE OBJECTS ---
  "道具": "🛠️", "ハンマー": "🔨", "建設": "🏗️", "工作": "🎨", "ペン": "🖊️",
  "鉛筆": "✏️", "本": "📖", "読む": "📚", "書く": "✍️", "学ぶ": "🎓",
  "学校": "🏫", "クラス": "🏫", "授業": "🏫", "科学": "🧪", "数学": "🧮", "歴史": "📜",
  "芸術": "🎨", "音楽": "🎵", "歌": "🎶", "ゲーム": "🎮", "遊ぶ": "🎮",
  "スポーツ": "⚽", "ボール": "⚽", "走る": "🏃", "ジム": "🏋️",
  "車": "🚗", "バス": "🚌", "電車": "🚆", "飛行機": "✈️", "旅行": "🧳",
  "家": "🏠", "部屋": "🚪",
  "プレゼント": "🎁", "箱": "📦", "鞄": "👜", "バッグ": "👜"
};

// Optimization: Pre-calculate sorted keys to ensure longest match wins
// This is done once at module load time to avoid re-sorting on every render
const sortedKeys = Object.keys(emojiMap).sort((a, b) => b.length - a.length);

export const getEmoji = (text: string): string | null => {
  if (!text) return null;
  const lower = text.toLowerCase();
  
  // 1. Direct match (Fast O(1))
  if (emojiMap[lower]) return emojiMap[lower];

  // 2. Keyword inclusion match (longest match wins)
  // We iterate through the pre-sorted keys
  for (const key of sortedKeys) {
    if (lower.includes(key)) {
      return emojiMap[key];
    }
  }

  return null;
};
